import './video-intro.scss';
require('../../images/video-scroll/vignette.png');

class VideoIntro {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-videointro',
            mediaAttr: 'media',
            replayAttr: 'replay',
            soundAttr: 'sound'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$videoIntro = element;
        this.$videoIntroMedia = this.$videoIntro.querySelector('[' + this.settings.initAttr + '="' + this.settings.mediaAttr + '"]');
        this.$videoIntroReplayButton = this.$videoIntro.querySelector('[' + this.settings.initAttr + '="' + this.settings.replayAttr + '"]');
        this.$videoIntroSoundButton = this.$videoIntro.querySelector('[' + this.settings.initAttr + '="' + this.settings.soundAttr + '"]');
        this.videoPlaying = false;
        this.muted = true;
        window.hasVideo = true;

        if (this.$videoIntroMedia === null) {
            console.error('no element found with ' + this.settings.initAttr + '="' + this.settings.mediaAttr + '"');
        }
    }

    initialize () {
        const playPromise = this.$videoIntroMedia.play();

        if (playPromise !== undefined) {
            playPromise.then(() => {
                this.$videoIntroMedia.pause();

                if (this.$videoIntroMedia.getAttribute('data-moodvideo') === null) {
                    if (this.$videoIntroMedia.readyState > 3) {
                        this.$videoIntroMedia.play();
                    } else {
                        this.$videoIntroMedia.addEventListener('canplaythrough', () => {
                            this.$videoIntroMedia.play();
                        });
                    }
                }

                this.setEvents();
            })
                .catch();
        }
    }

    setEvents () {
        this.$videoIntroMedia.addEventListener('ended', () => {
            this.$videoIntro.classList.add('is--media-ended');
            this.$videoIntroMedia.setAttribute('playing', false);
            this.videoPlaying = false;
            window.dispatchEvent(new Event('video-intro-ended'));
        });

        this.$videoIntroMedia.addEventListener('pause', () => {
            this.$videoIntro.classList.add('is--media-ended');
            this.$videoIntroMedia.setAttribute('playing', false);
            this.videoPlaying = false;

            if (this.$videoIntroMedia.muted === false && this.$videoIntroSoundButton !== null) {
                this.$videoIntroMedia.muted = true;
                this.$videoIntroSoundButton.classList.remove('has--volume');
            }

            window.dispatchEvent(new Event('video-intro-paused'));
        });

        this.$videoIntroMedia.addEventListener('play', () => {
            this.$videoIntro.classList.remove('is--media-ended');
            this.$videoIntroMedia.setAttribute('playing', true);
            this.videoPlaying = true;
        });

        if (this.$videoIntroReplayButton !== null) {
            this.$videoIntroReplayButton.addEventListener('click', () => {
                this.$videoIntroMedia.play();
                window.dispatchEvent(new Event('video-intro-restart'));
            });
        }

        if (this.$videoIntroSoundButton !== null) {
            this.$videoIntroSoundButton.addEventListener('click', () => {
                if (this.$videoIntroMedia.muted === true) {
                    this.$videoIntroMedia.muted = false;
                    this.$videoIntroSoundButton.classList.add('has--volume');
                } else {
                    this.$videoIntroMedia.muted = true;
                    this.$videoIntroSoundButton.classList.remove('has--volume');
                }
            });
        }
    }
}

export { VideoIntro };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$videoIntros = $context.querySelectorAll('[data-videointro="root"]');

        if ($$videoIntros.length > 0) {
            for (let i = 0; i < $$videoIntros.length; i++) {
                const $videoIntro = new VideoIntro($$videoIntros[i]);
                $videoIntro.initialize();
            }
        }
    }
});
